// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"58014027","240":"2c49715e","279":"c3c67322","900":"9706779e"}[chunkId] + ".css";
};